import axios from "axios";

export const EngagespotApiService = (data) => {
  return axios.get(`/notifications/engagespot/details`, data);
};

export const EngagespotInAppFalseApiService = (data) => {
  return axios.get(`/notifications`, data);
};
